module.exports = __webpack_public_path__ + "3871079c2b68d4c128cc8e25b0aecb8d.png";